module.exports = __webpack_public_path__ + "static/media/_MIC2467.thumbnail.7fa0a4db.png";